// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, sessionExpired, clearSessionExpired } = useAuth();
  
  // Show session expired message if applicable
  useEffect(() => {
    if (sessionExpired) {
      setError('Your session has expired. Please sign in again.');
      // Clear the expired flag after showing the message
      clearSessionExpired();
    }
  }, [sessionExpired, clearSessionExpired]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    const result = await login(username, password);
    if (!result.success) {
      setError(result.message);
    }
  };
  
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-6 px-4 sm:px-6 lg:px-8" style={{alignItems: 'flex-start', paddingTop: '15vh'}}>
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">originzone</h1>
          <div className="w-16 h-1 bg-[#fafa00] mx-auto mb-6"></div>
          <h2 className="text-xl font-medium text-gray-700">Sign in to your account</h2>
        </div>
        
        <div className="bg-white py-8 px-6 shadow-sm rounded-lg border border-gray-200">
          {error && (
            <div className={`mb-6 p-4 border rounded-md text-sm ${
              error.includes('expired') 
                ? 'bg-amber-50 border-amber-200 text-amber-700' 
                : 'bg-red-50 border-red-200 text-red-700'
            }`}>
              {error}
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Username
              </label>
              <input 
                type="text" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                className="w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#fafa00] focus:border-transparent transition duration-200" 
                placeholder="Enter your username"
                required 
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Password
              </label>
              <input 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                className="w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#fafa00] focus:border-transparent transition duration-200" 
                placeholder="Enter your password"
                required 
              />
            </div>
            
            <button 
              type="submit" 
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-black bg-[#fafa00] hover:bg-[#e6e600] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#fafa00] transition duration-200"
            >
              Sign in
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
